'use strict'

/**
 * Call this whenever information about your visitors becomes available
 * Please use Strings, Numbers, or Bools for value types.
 * For more information access https://help.pendo.io
 */

export default function pendoInitialize ({ user, payment, companyInfo }) {
  const obj = Object.keys(companyInfo).length ? {
    visitor: {
      id: user.id, // required if user is logged in
      role: user.permission,
      email: user.email,

      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
      webcall: user.webCall,
      paymentHasServiceBilling: payment.hasServiceBilling,
      paymentIsPending: payment.isPending,
      paymentUseCreditCard: payment.useCreditCard
    },
    account: {
      id: companyInfo.id,
      name: companyInfo.name,
      POD: companyInfo.plan,
      paymentIsPending: payment.isPending,
      paymentUseCreditCard: payment.useCreditCard,
      paymentHasServiceBilling: payment.hasServiceBilling
      // planLevel: // optional
      // planPrice: // optional
      // creationDate: // optional

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    }
  } : {
    visitor: {
      id: user.id, // required if user is logged in
      role: user.permission,
      email: user.email,
      webcall: user.webCall,

      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
      paymentHasServiceBilling: payment.hasServiceBilling,
      paymentIsPending: payment.isPending,
      paymentUseCreditCard: payment.useCreditCard
    }
  }

  window.pendo.initialize(obj)
}
